export default __webpack_public_path__ + "static/media/logo_3.cb4d8f49.png";